import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Dropdown } from '@components/Form/Autocomplete'
import TextArea from '../Form/TextArea'
import propTypes from 'prop-types'
import './Modals.sass'
import { Formik, Form, Field } from 'formik'
import Button from '@components/Button'
import yup from 'yup'
import FormError from '@components/FormError/FormError'

const OTHER_REJECTION_REASONS = 5

class RejectModal extends Component {
  static propTypes = {
    toggleShowModal: propTypes.func,
    paymentDetailsStore: propTypes.object,
    reasonsList: propTypes.object,
    label: propTypes.string,
    isVisible: propTypes.bool
  }

  static defaultProps = {
    hideButtons: true,
    showCloseIcon: true,
    shouldCloseOnOverlayClick: true
  }

  state = {
    error: null
  }

  getInitialFormValues () {
    return {
      rejectionReasonId: null,
      rejectionDescription: ''
    }
  }

  getValidationSchema = () => {
    let validationSchema = {
      rejectionReasonId: yup
        .number()
        .integer()
        .required('Rejection reason is required')
        .typeError('Rejection reason is required')
    }

    if (this.rejectionReasonId === OTHER_REJECTION_REASONS) {
      validationSchema.rejectionDescription = yup
        .string()
        .required('Rejection description is required')
    }

    return yup.object().shape(validationSchema)
  }

  updateValidation = (rejectionReason, form) => {
    form.setFieldValue('rejectionReasonId', rejectionReason.id, false)

    form.setFieldValue('rejectionReason.id', rejectionReason.id, false)
    form.setFieldValue('rejectionReason.name', rejectionReason.name, false)
    this.rejectionReasonId = rejectionReason.id
  }

  handleSubmit = values => {
    const { paymentDetailsStore, toggleShowModal, reasonsList } = this.props

    const { rejectionReasonId, rejectionDescription } = values

    const paymentDetails = { ...paymentDetailsStore.paymentDetails }

    const epdRejectionReason = reasonsList.find(reason => {
      return reason.id === rejectionReasonId
    })

    paymentDetails.epdRejectionReason = epdRejectionReason
    paymentDetails.epdRejectionReasonId = epdRejectionReason.id
    paymentDetails.epdRejectionDescription = rejectionDescription

    paymentDetailsStore.incompletePaymentDetails(paymentDetails)

    toggleShowModal()
  }

  render () {
    if (!this.props.isVisible) return null
    return (
      <div className='modalWrapper'>
        <div className='modalWrapper__box'>
          <div className='modalWrapper__box__content'>
            <Formik
              initialValues={this.getInitialFormValues()}
              validationSchema={this.getValidationSchema}
              onSubmit={this.handleSubmit}
              render={form => (
                <div>
                  {this.props.label}
                  <FormError error={this.state.error} />
                  <Form onSubmit={form.handleSubmit}>
                    <div className='expert-form__section'>
                      <Field
                        label='Rejection reason'
                        name='rejectionReasonId'
                        placeholder='Select title'
                        itemToString={item => item && item.name}
                        options={this.props.reasonsList}
                        onChange={value => this.updateValidation(value, form)}
                        component={Dropdown}
                      />
                      {form.values.rejectionReasonId ===
                      OTHER_REJECTION_REASONS ? (
                        <Field
                          name='rejectionDescription'
                          label='Description'
                          component={TextArea}
                        />
                      ) : (
                        ''
                      )}
                    </div>
                    <div className='expert-form__section'>
                      <Button
                        primary
                        submit
                        onClick={this.onSubmit}
                        disabled={form.isSubmitting}
                      >
                        Save
                      </Button>
                      <Button
                        onClick={this.props.toggleShowModal}
                        disabled={form.isSubmitting}
                      >
                        Cancel
                      </Button>
                    </div>
                  </Form>
                </div>
              )}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default observer(RejectModal)
